<header class="app-header">
    <section class="navbar d-flex">
        <ng-content></ng-content>

        <section class="ms-auto d-flex align-items-center">
            <ng-content select="[appBarOptions]"></ng-content>
        </section>
    </section>
</header>
